import React, { useState } from 'react';
import styles from './CSS/NewsLetter.module.css';
import { useNewsletterSubscription } from '../../hooks/useNewsLetter';
import { toast } from 'react-toastify';

function NewsLetter() {
  const [email, setEmail] = useState('');
  const subscription = useNewsletterSubscription();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateEmail(email)) {
      try {
        await subscription.mutateAsync(email);
        setEmail('');
      } catch (error) {
        toast.error('Failed to subscribe. Please try again.',error);
      }
    }
  };

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  return (
    <div className={styles.container}>
      <div className={styles.overlay}>
        <div className={styles.newsletterBox}>
          <div className={styles.content}>
            <h2 className={styles.title}>Subscribe to our Newsletter</h2>
            <p className={styles.subtitle}>Stay tuned with our latest releases</p>
            
            <form onSubmit={handleSubmit} className={styles.form}>
              <div className={styles.inputWrapper}>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className={styles.input}
                  required
                  disabled={subscription.isLoading}
                />
                <button 
                  type="submit" 
                  className={styles.button}
                  disabled={subscription.isLoading}
                >
                  <span className={styles.buttonText}>
                    {subscription.isLoading ? 'Subscribing...' : 'Subscribe'}
                  </span>
                  <span className={styles.buttonIcon}>→</span>
                </button>
              </div>
              {subscription.isSuccess && (
                <p className={styles.successMessage}>You're in! Welcome aboard! 🎉</p>
              )}
              {subscription.isError && (
                <p className={styles.errorMessage}>
                  {subscription.error?.response?.data?.message || 'Failed to subscribe. Please try again.'}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewsLetter;